import get from 'lodash/get';

export const parseError = (error) => {
  const detail = get(error, 'response.data.Detail');
  const errorsObject = get(error, 'response.data.errors');
  const description = get(error, 'response.data.Description');
  const statusText = get(error, 'response.StatusText');
  const innerExceptionText = get(error, 'response.data.InnerException');

  if (errorsObject && Object.keys(errorsObject).length > 0) {
    const errors = Object.keys(errorsObject).map((errKey) => errorsObject[errKey]);
    const errorsListStr = errors.join('\n');
    return errorsListStr;
  }

  if (detail) {
    if (typeof detail === 'string' && detail.indexOf('{') >= 0) {
      try {
        const parsed = JSON.parse(detail);
        if (parsed && parsed.message) {
          return parsed.message;
        }
      } catch {
        return error;
      }
    }
    return detail + (innerExceptionText ? (`\n ${innerExceptionText}`) : '');
  }
  if (description) {
    return description + (innerExceptionText ? (`\n ${innerExceptionText}`) : '');
  }
  if (statusText) {
    return statusText;
  }
  if (error.message) {
    return error.message;
  }
  return error;
};
